import './article.scss';
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import { useState, useEffect, useContext, useRef, Fragment, useCallback, useMemo } from 'react';
import { ArticleContext } from '../../components/context';
import { Store } from 'react-notifications-component';
import SoldOutIcon from './stampsold01.svg'
import useCart from '../../hooks/useCart';
import axios from 'axios';
import { PHP_URL } from '../../config/env';

export const translateText = (key) => {
  const map = {
    Ticket: 'Hardticket',
    ETicket: 'Print@Home Ticket',
    FrontPrintGross: 'Frontprint Logo groß',
    FrontPrintKlein: 'Frontprint Logo klein',
    Backprint: 'Backprint Bands'
  }
  return map[key] || key;
}
export default function Article() {
  const params = useParams()
  const { articleData } = useContext(ArticleContext);
  const [size, setSize] = useState(null);
  const [amount, setAmount] = useState(1);
  const [amountTent, setAmountTent] = useState(null);
  const [amountCamper, setAmountCamper] = useState(null);
  const [currentlySold, setCurrentlySold] = useState(0);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const cart = useCart();
  const [selectedOption, setSelectedOption] = useState(0);
  const location = useLocation();
  const search = location.pathname.replace('/shop/artikel/', '');
  const attributes = articleData.find(x => x.id === parseInt(search));
  const current = attributes.attributes;
  current.id = attributes.id;
  const [index, setIndex] = useState(0);
  const delay = 6000;
  const timeoutRef = useRef(null);
  const [sliderImages, setSliderImages] = useState(current.bilder.data);

  /**
   * Aktualisiert die anzuzeigenden Bilder
   * @param {number} optionIndex - Der Index der ausgewählten Option oder undefined/null für Standardbilder des Artikels
   */
  const updateSliderImages = useCallback(optionIndex => {
    const validOption = optionIndex !== undefined && optionIndex !== null
    const hasImagesForOption = validOption && !!(current.optionen[optionIndex]?.bilder?.data)
    if (hasImagesForOption) {
      setSliderImages(current.optionen[optionIndex].bilder.data);
    } else {
      setSliderImages(current.bilder.data)
    }
    setIndex(0)
  }, [setSliderImages, setIndex, current.optionen, current.bilder.data])

  /**
   * Resettet ggf. die ausgewählte Größe beim Wechsel der Option, wenn die bisherige Größe für die neue Option nicht verfügbar ist
   * @param {number} optionIndex - Der Index der neu ausgewählten Option
   */
  const updateSize = useCallback(optionIndex => {
    const currentSize = size
    if (current.optionen[optionIndex]?.sizes) {
      if (!current.optionen[optionIndex].sizes[currentSize?.toLocaleUpperCase()]) {
        setSize(null)
      }
    } else if (current.sizes) {
      if (!current.sizes[currentSize?.toLocaleUpperCase()]) {
        setSize(null)
      }
    }
  }, [current, size, setSize])

  useEffect(() => {
    updateSliderImages(0)
  }, [params.id, current.bilder.data, updateSliderImages])

  const hasOptions = current.optionen.length !== 0;
  const optionHasSizes = hasOptions && current.optionen[selectedOption] && current.optionen[selectedOption].sizes;
  const hasSizes = optionHasSizes || (current.sizes && Object.keys(current.sizes).length > 0);

  /**
   * Wie viele Artikel von genau diesem (Option+Größe) Produkt sind laut CMS-Daten maximal verfügbar?
   */
  const maxToSell = useMemo(() => {
    if (optionHasSizes) {
      if (selectedOption !== null && selectedOption !== undefined && size) {
        return current.optionen[selectedOption].sizes[size.toLocaleUpperCase()] ?? 0
      } else {
        return Number.POSITIVE_INFINITY
      }
    }
    else if (hasSizes) {
      if (size) {
        return current.sizes[size.toLocaleUpperCase()] ?? 0
      } else {
        return Number.POSITIVE_INFINITY
      }
    }
    else if (hasOptions) {
      if (selectedOption !== null && selectedOption !== undefined) {
        return current.optionen[selectedOption].anzahl ?? 0
      } else {
        return Number.POSITIVE_INFINITY
      }
    }
    else {
      return current.anzahl ?? 0
    }
  }, [current, selectedOption, size, hasOptions, hasSizes, optionHasSizes])

  const isSoldOut = () => {
    return current.soldOutLogo || (currentlySold >= maxToSell)
  }
  const needsSize = hasSizes && !size;
  const needsOption = hasOptions && (selectedOption === null || selectedOption === undefined);

  const titleClass = current.type === 'BAK' ? 'BAK title' : 'title'
  const getButtonText = () => {
    if (isLoading) {
      return 'Bitte warten...'
    } else if (needsOption) {
      return 'Option auswählen'
    } else if (needsSize) {
      return 'Größe auswählen'
    } else if (isSoldOut()) {
      return 'Ausverkauft!'
    } else {
      return 'In den Warenkorb'
    }
  }
  const sizesMenu = optionHasSizes ? current.optionen[selectedOption].sizes : hasSizes ? current.sizes : {};
  const options = [];
  Object.keys(current.optionen).forEach(function (key, index) {
    options.push(current.optionen[key].name)
  })
  const putIntoCart = () => {
    const currentItem = { amount, ...current };
    if (hasSizes) { currentItem.size = size }
    if (current.showCamperOption) { currentItem.amountCamper = amountCamper }
    if (current.showTentOption) { currentItem.amountTent = amountTent }
    if (hasOptions) {
      currentItem.option = current.optionen[selectedOption].name;
      currentItem.bilder =
        current.optionen[selectedOption]?.bilder?.data?.length > 0
          ? current.optionen[selectedOption].bilder
          : current.bilder;
    }
    currentItem.anzahl = maxToSell;
    currentItem.currentlySold = currentlySold;
    if ((current.showTentOption && !amountTent && amountTent !== 0) || (current.showCamperOption && !amountCamper && amountCamper !== 0)) {
      Store.addNotification({
        title: "Fehler",
        message: "Bitte die Anzahl der Wohnwagen bzw. Zeltstellplätze auswählen",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true
        }
      });
      return
    }

    // sollte eigentlich nicht möglich sein - aber den check gab es scheinbar schon länger...
    if (amount <= 0) {
      return
    }

    const cartAmount = cart.getAmount(currentItem);
    if (hasSizes) {
      if (sizesMenu[size.toLocaleUpperCase()] === undefined || sizesMenu[size.toLocaleUpperCase()] < 1) {
        Store.addNotification({
          title: "Fehler",
          message: "Die Größe " + size.toUpperCase() + " ist nicht verfügbar.",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true
          }
        });
        return
      }
    }
    if (maxToSell > 0 && currentlySold + amount + cartAmount > maxToSell) {
      Store.addNotification({
        title: "Fehler",
        message: "Es sind nur noch " + (maxToSell - currentlySold) + " Artikel verfügbar.",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true
        }
      });
      return
    }
    if (cart.items.length === 0 && current.subType1 === 'Support') {
      Store.addNotification({
        title: "Fehler",
        message: "Du kannst das Supporterpaket nur zusammen mit anderen Artikeln bestellen.",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true
        }
      });
      return
    }

    cart.add(currentItem)

    Store.addNotification({
      title: "Artikel hinzugefügt",
      message: current.name + " liegt jetzt im Warenkorb",
      type: "success",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 3000,
        onScreen: true
      }
    });
  }

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  useEffect(() => {
    if (index >= sliderImages.length && sliderImages.length > 0) {
      setIndex(0);
    }
  }, [index, sliderImages.length]);

  useEffect(() => {
    resetTimeout();
    if (sliderImages.length <= 1) {
      return () => {
        resetTimeout();
      };
    }

    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === sliderImages.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    );

    return () => {
      resetTimeout();
    };
  }, [index, sliderImages.length]);

  const getMaxCount = useCallback(async () => {
    if (hasLoaded === current.id + size + selectedOption) return;

    if (needsOption || needsSize) {
      return setCurrentlySold(0)
    }

    setIsLoading(true);
    try {
      const sizeParam = hasSizes ? size : '';
      const response = await axios.get(`${PHP_URL}/count.php?x=${current.id}-${sizeParam}-${selectedOption}`);
      const value = parseInt(response.data, 10);
      setHasLoaded(current.id + size + selectedOption);
      setIsLoading(false);
      if (!isNaN(value)) setCurrentlySold(value);
    } catch (error) {
      console.error(error);
    }
  }, [hasLoaded, current.id, size, selectedOption, hasSizes, needsOption, needsSize]);

  useEffect(() => {
    getMaxCount();
  }, [getMaxCount, hasLoaded, size, selectedOption, current.id, hasSizes]);

  const onOptionChange = (option) => {
    updateSliderImages(option)
    updateSize(option)
    setSelectedOption(option);
    getMaxCount();
  };
  const onSizesChange = (size) => {
    setSize(size);
    getMaxCount();
  };
  return (
    <div className='articleBox'>
      <div className='content'>
        <div className='box'>
          <div className='articlePic'>
            <div className="slideshow">
              <div
                className="slideshowSlider"
                style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
              >
                {sliderImages.map((item, index) => (
                  <div
                    className="slide"
                    key={item.attributes?.formats?.small?.url}
                  ><img key={item.attributes?.formats?.small?.url} src={item.attributes?.formats?.small?.url} alt={current.name + '- Artikel Image'} /></div>
                ))}
              </div>

              <div className="slideshowDots">
                {sliderImages.map((_, idx) => (
                  <div
                    key={idx}
                    className={`${current.type} slideshowDot${index === idx ? " active" : ""}`}
                    onClick={() => {
                      setIndex(idx);
                    }}
                  ></div>
                ))}
              </div>
            </div>
            {isSoldOut() && <img className='soldOut' src={SoldOutIcon} alt="Sold out banner" />}
          </div>
          <div className='text'>
            <h1 className={titleClass}>{current.name}</h1>
            <h3 className="subtitle">{translateText(current.subType1)}{translateText(current.subType2) ? ` | ${translateText(current.subType2)}` : ''}{translateText(current.subType3) ? ` | ${translateText(current.subType3)}` : ''}</h3>

            <ProduktgruppeAuswahl item={current} />

            {current.optionen.length !== 0 && <>
              <span>Option wählen:&nbsp;</span> <select
                className='optionSelect'
                value={selectedOption}
                onChange={e => onOptionChange(e.target.value)}
              >
                {options.map((idx, key) => (
                  <option key={key} value={key}>{idx}</option>
                ))}
              </select>
            </>}
            {hasSizes &&
              <div className={current.type + " wrapper"}>
                {
                  Object.keys(sizesMenu)
                    .filter(key => key !== 'id')
                    .map((key, index) => {
                      if (sizesMenu[key] > 0) {
                        return (<Fragment key={key + index}>
                          <input
                            type="radio"
                            name="select"
                            key={'opt' + key + index}
                            onChange={e => onSizesChange(e.target.value)}
                            id={"option-" + index}
                            checked={size === key.toLowerCase()}
                            value={key.toLowerCase()}
                          />
                          <label
                            htmlFor={"option-" + index}
                            className={"option option-" + index}
                          >
                            <span>
                              {{
                                'XXL': '2XL',
                                'XXXL': '3XL',
                                'XXXXL': '4XL',
                              }[key] ?? key}
                            </span>
                          </label>
                        </Fragment>
                        );
                      }
                      return null;
                    })
                }
              </div>
            }

            {current.showCamperOption &&
              <div className='orderControl'>
                <input
                  className="amount"
                  type="number"
                  name="amountTent"
                  onChange={e => setAmountTent(Math.max(0, e.target.value))}
                  value={amountTent} />
                kostenfreier Zeltplatz
                <br />
              </div>
            }

            {current.showTentOption &&
              <div className='orderControl'>
                <input
                  className="amount"
                  type="number"
                  name="amountCamper"
                  onChange={e => setAmountCamper(Math.max(0, e.target.value))}
                  value={amountCamper} />
                kostenfreier Wohnwagen / Camper Stellplatz
                <br />
              </div>
            }

            <ReactMarkdown>{current.beschreibung}</ReactMarkdown>

            <div className="prices">
              Preis: <div className="amount">{current.preis.toFixed(2)} €</div>
            </div>

            <div className='orderControl'>
              <div className='amountLabel'><input className='amount' type="number" name="amount" onChange={e => setAmount(current.subType1 === 'Support' ? 1 : Math.max(0, e.target.value))} value={amount} /> </div>
              <button disabled={isLoading || isSoldOut() || needsOption || needsSize} className={current.type + ' button'} onClick={e => putIntoCart()}>{getButtonText()}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function ProduktgruppeAuswahl(props) {
  const navigate = useNavigate()
  const { productgroupData = [] } = useContext(ArticleContext);
  const { item } = props
  const produktgruppen = productgroupData.filter(group => {
    return group?.attributes?.items?.data.some(it => (it.attributes.produkt?.data?.id ?? it.attributes.produkt?.id) === item?.id)
  })

  const onChange = useCallback((e) => {
    navigate(`/shop/artikel/${e.currentTarget.value}`)
  }, [navigate])

  if (produktgruppen.length === 0) {
    return null
  }

  return (
    <div className="produktgruppen">
      {produktgruppen.map(gruppe =>
        <div key={gruppe.id} className="produktgruppe">
          <label>
            {gruppe.attributes.beschreibung}:&nbsp;
            <select value={item.id} onChange={onChange}>
              {gruppe.attributes.items.data.map(it =>
                <option key={it.id} value={it.attributes.produkt?.data?.id ?? it.attributes.produkt?.id}>
                  {it.attributes.beschreibung}
                </option>
              )}
            </select>
          </label>
        </div>
      )}
    </div>
  )
}